import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import tokenUitl from '@/utils/token' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// '/Supplier' //20260608去掉供应商页面跳转，不支持无登陆跳转
const whiteList = ['/','/login','/forgetPassword','/PublicAnnouncementList','/Registered','/projectList',
                    '/ForgetPassword','/itemDetails','/SupplierDetails','/CreditAnnouncementList',
                    '/PublicAnnouncementList','/itemBadRecord','/Complaints','/authingIndex','/DetailManagement'] // 没有重定向白名单

router.beforeEach(async(to, from, next) => {
  // 开始进度条
  NProgress.start();

  // 设置页面标题
  document.title = getPageTitle(to.meta.title)

  console.log("路由地址="+to.path)

  // 确定用户是否已登录
  const hasToken = tokenUitl.getToken()

  // console.log("hasToken="+hasToken);

  /*if (hasToken&&hasToken!='undefined') {*/
  if (hasToken&&hasToken!='undefined') {

    // if (to.path === '/') { // 如果已登录，请重定向到主页
    //   next({ path: '/' });
    //   NProgress.done()
    // } else {
      next()
    // }
  } else {
    /*登录令牌过时*/
    console.log("没进来了fales")
    if (whiteList.indexOf(to.path) !== -1) {// 在登录白名单中，直接进入
      next()
    } else { // 其他没有访问权限的页面将重定向到登录页面。
      next(`/`);
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // 进度条结束
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js